// @flow

import type { PackageContentTable } from '../../../types/pdb';
import { getEntries, firstLastSortArray } from '../../../helpers';

type Arguments = {
  packageContents: PackageContentTable,
};

const sortPackageCompareTable = (packageContents: Arguments) => (
  firstLastSortArray<any>(getEntries(packageContents).sort((a, b) => (
    // Sort contents objects based on [key, value] = value.length
    Object.keys(a[1]).length > Object.keys(b[1]).length ? 1 : -1
  )))
);

export default sortPackageCompareTable;
